/*
 * @Author: your name
 * @Date: 2021-01-29 14:22:38
 * @LastEditTime: 2021-02-02 10:11:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \shopManagement\src\router\index.js
 */
import login from "@/pages/login";
import Vue from "vue";
import Router from "vue-router";
import aftersaleRouter from "./modules/aftersaleRouter";
import basicRouter from "./modules/basicRouter";
// import invoiceRouter from './modules/invoice'
import notice from "./modules/notice";
import chatRouter from "./modules/orderList";
import orderRouter from "./modules/orderRouter";
import reportRouter from "./modules/reportRouter";
import stockRouter from "./modules/stockRouter";
// 原有见证宝的钱袋的模块
import userSet from "./modules/userSet";
import reportCenter from "./modules/reportCenter";
import dataReportRouter from "./modules/dataReportRouter";
import settlementRouter from "./modules/settlementRouter";
// import r4SettlementUserSet from "./modules/r4SettlementUserSet";
// 对接清分后 改造的 连连钱袋和锐锢钱袋走新的模块 2022-06-30 purseSet
import purseSet from "./modules/purseSet";
import r4SettlementReportRouter from "./modules/r4SettlementReportRouter";
import orderReport from "./modules/orderReport";

Vue.use(Router);
export let constantRoutes = [
  {
    path: "/login",
    name: "login",
    hidden: true,
    component: login
  },
  {
    path: "/",
    name: "home",
    hidden: true,
    redirect:
      localStorage.getItem("is_jgj") === "1"
        ? "/order/manageFastener"
        : "/order/manage"
  }
];
// todo:r4
export let asyncRoutes = [
  dataReportRouter,
  orderRouter,
  aftersaleRouter,
  stockRouter,
  reportRouter,
  r4SettlementReportRouter,
  settlementRouter,
  basicRouter,
  notice,
  userSet,
  purseSet,
  chatRouter,
  reportCenter,
  orderReport
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

let router = createRouter();

// // Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js